import { ContentSettingDashboard } from '@packages/models/api';
import { action, on, props, reducer, union } from 'ts-action';
import { Dispatch, Reducer } from 'react';

export enum DashboardActionsList {
    CLEAR_DASHBOARD_DATA = 'CLEAR_DASHBOARD_DATA',
    HAS_ERRORS = 'HAS_ERRORS',
    HAS_FETCHED = 'HAS_FETCHED',
    HAS_LOADED = 'HAS_LOADED',
    IS_LOADING = 'IS_LOADING',
    SET_DASHBOARD_DATA = 'SET_DASHBOARD_DATA',
}

export const dashboardActions = {
    clearDashboardData: action(DashboardActionsList.CLEAR_DASHBOARD_DATA),
    hasErrors: action(DashboardActionsList.HAS_ERRORS, props<{ errors: string[] }>()),
    hasFetched: action(DashboardActionsList.HAS_FETCHED),
    hasLoaded: action(DashboardActionsList.HAS_LOADED),
    isLoading: action(DashboardActionsList.IS_LOADING),
    setDashboardData: action(
        DashboardActionsList.SET_DASHBOARD_DATA,
        props<{ dashboardData: ContentSettingDashboard }>()
    ),
};

const actionsUnion = union(...Object.values(dashboardActions));
type DashboardActions = typeof actionsUnion.actions;
export type DashboardActionDispatcher = Dispatch<DashboardActions>;

export interface DashboardState {
    dashboardData: ContentSettingDashboard;
    errors: string[];
    hasFetched: boolean;
    loading: boolean;
}

export const initialState: DashboardState = {
    dashboardData: {
        techline: [],
    },
    errors: [],
    hasFetched: false,
    loading: false,
};

export const dashboardReducer: Reducer<DashboardState, DashboardActions> = reducer(
    initialState,
    on(dashboardActions.clearDashboardData, (state) => {
        return {
            ...state,
            dashboardData: {},
        };
    }),
    on(dashboardActions.hasFetched, (state) => {
        return {
            ...state,
            hasFetched: true,
        };
    }),
    on(dashboardActions.isLoading, (state) => {
        return {
            ...state,
            loading: true,
        };
    }),
    on(dashboardActions.hasLoaded, (state) => {
        return {
            ...state,
            loading: false,
        };
    }),
    on(dashboardActions.hasErrors, (state, { errors }) => {
        return {
            ...state,
            errors,
        };
    }),
    on(dashboardActions.setDashboardData, (state, { dashboardData }) => {
        return {
            ...state,
            dashboardData,
        };
    })
);
